import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { BasePostStyles, BaseTitle, Text } from "../../posts.styles";

export const Post = styled.div`
	${BasePostStyles}
	background-color: ${colours.white};
	border: solid 2px ${colours.red};
`;

export const Title = styled.div`
	${BaseTitle}
`;

export { Text, BaseTitle };
